<template>
  <div class="relative p-4 border rounded-10 border-slate-300 dark:border-zinc-700 flex items-center gap-4" data-testid="transcription-upselling-inline">
    <p class="dark:text-zinc-500">
      Automatically add titles, descriptions, and transcriptions to your videos to provide greater context & enhanced searchability.
    </p>
    <Button type="solid" variant="pink-gradient" icon="general.stars" href="/account/plans">Get AI add-on</Button>
    <Button type="link" variant="black" icon="general.crossLight" @click.prevent="emit('close')" />
  </div>
</template>

<script setup lang="ts">
import { Button } from '@/storybook';

const emit = defineEmits(['close']);
</script>

<style scoped></style>
